"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _core = require("@material-ui/core");

var _formik = require("formik");

var _formFields = require("react-platform-components/dist/form-fields");

var _formValidators = require("react-platform-components/dist/form-validators");

var _Translations = require("react-platform-components/dist/Translations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OptionOfProductField = /*#__PURE__*/function (_React$Component) {
  _inherits(OptionOfProductField, _React$Component);

  var _super = _createSuper(OptionOfProductField);

  function OptionOfProductField(props) {
    var _this;

    _classCallCheck(this, OptionOfProductField);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "showOptionalOptionsMenu", function (event) {
      _this.setState({
        anchorEl: event.currentTarget
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.setState({
        anchorEl: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddOptionalOption", function (item) {
      _this.setState({
        anchorEl: null,
        categoryOptionsOptional: _toConsumableArray(_lodash.default.filter(_this.state.categoryOptionsOptional, function (element) {
          return element.option.id !== item.option.id;
        }))
      });

      _this.props.setFieldValue('options', [].concat(_toConsumableArray(_this.props.values.options), [item]));
    });

    _defineProperty(_assertThisInitialized(_this), "handleRemoveOptionalOption", function (item) {
      _this.setState({
        categoryOptionsOptional: [].concat(_toConsumableArray(_this.state.categoryOptionsOptional), [item])
      });
    });

    _this.state = {
      anchorEl: null,
      categoryOptionsOptional: []
    };
    return _this;
  }

  _createClass(OptionOfProductField, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          categories = _this$props.categories,
          values = _this$props.values,
          options = _this$props.options,
          setFieldValue = _this$props.setFieldValue; // When the user is select a category we are get the options of selected category and display it

      if (categories && !_lodash.default.isEmpty(categories) && _lodash.default.get(values, 'category') !== _lodash.default.get(nextProps.values, 'category')) {
        var selectedCategory = _lodash.default.find(categories, {
          id: _lodash.default.get(nextProps.values, 'category')
        }); // We stock required options in categoryOptionsRequired for display directly
        // and we sotck optional options in categoryOptionsOptional for display when the user choose it from a menu


        var categoryOptionsRequired = [];
        var categoryOptionsOptional = [];

        var _iterator = _createForOfIteratorHelper(selectedCategory.deep_category_options || []),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var categoryOption = _step.value;

            var option = _objectSpread(_objectSpread({}, categoryOption), {}, {
              option: _lodash.default.find(options, {
                id: categoryOption.option.id
              })
            });

            if (categoryOption.required) {
              categoryOptionsRequired.push(option);
            } else {
              categoryOptionsOptional.push(option);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        this.setState({
          categoryOptionsOptional: categoryOptionsOptional
        });
        setFieldValue('options', categoryOptionsRequired);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var values = this.props.values;
      var categoryOptionsOptional = this.state.categoryOptionsOptional;

      if (!_lodash.default.get(values, 'category') || !values.options || _lodash.default.isEmpty(values.options) && _lodash.default.isEmpty(categoryOptionsOptional)) {
        // hide this fields when the category is not selected yet
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12,
        style: {
          marginTop: 35
        }
      }, /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
        name: "options",
        render: function render(arrayHelpers) {
          return /*#__PURE__*/_react.default.createElement(_core.Grid, {
            container: true,
            item: true,
            xs: 12,
            alignItems: "center"
          }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
            item: true,
            xs: 6
          }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
            variant: "subtitle1",
            className: "pl-2",
            style: {
              fontSize: '1.1rem',
              color: '#908f8f'
            }
          }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
            id: "Options"
          }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
            container: true,
            item: true,
            xs: 6,
            justify: "flex-end"
          }, /*#__PURE__*/_react.default.createElement(_core.Button, {
            variant: "outlined",
            color: "primary",
            disabled: categoryOptionsOptional.length === 0,
            "aria-controls": "simple-menu",
            "aria-haspopup": "true",
            onClick: _this2.showOptionalOptionsMenu
          }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
            id: "Ajouter"
          })), /*#__PURE__*/_react.default.createElement(_core.Menu, {
            id: "simple-menu",
            anchorEl: _this2.state.anchorEl,
            keepMounted: true,
            open: Boolean(_this2.state.anchorEl),
            onClose: _this2.handleClose
          }, categoryOptionsOptional.map(function (item, index) {
            return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
              key: index,
              onClick: function onClick() {
                return _this2.handleAddOptionalOption(item);
              }
            }, item.option.name);
          }))), values.options && values.options.map(function (element, index) {
            return /*#__PURE__*/_react.default.createElement(_core.Grid, {
              item: true,
              xs: 12,
              key: index
            }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
              container: true,
              item: true,
              xs: 12,
              className: index === 0 ? 'py-2 pt-4' : 'py-2'
            }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
              item: true,
              xs: element.required ? 12 : 11
            }, element.option.type === 'list' ? /*#__PURE__*/_react.default.createElement(_formFields.Select, {
              variant: "outlined",
              fullWidth: true,
              margin: "normal",
              required: element.required,
              value: values.options[index].choice || [],
              label: element.option.name,
              name: "options[".concat(index, "].choice"),
              validate: element.required ? (0, _formValidators.required)() : function () {},
              onChange: function onChange(event) {
                _this2.props.setFieldValue("options.".concat(index, ".choice"), event.target.value);
              },
              multiple: true
            }, element.option.choices && element.option.choices.map(function (choice) {
              return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
                key: choice.id,
                value: choice.id
              }, choice.name);
            })) : element.option.type === "date" ? /*#__PURE__*/_react.default.createElement(_formFields.MultiDatePicker, {
              value: values.options[index].choice || [],
              label: element.option.name,
              required: element.required,
              validate: element.required ? (0, _formValidators.required)() : function () {},
              name: "options[".concat(index, "].choice"),
              onChange: function onChange(dates) {
                _this2.props.setFieldValue("options.".concat(index, ".choice"), dates);
              }
            }) : element.option.type === "boolean" ? /*#__PURE__*/_react.default.createElement(_formFields.Checkbox, {
              fullWidth: true,
              margin: "normal",
              label: element.option.name,
              value: values.options[index].choice || false,
              color: "primary",
              required: element.required,
              validate: element.required ? (0, _formValidators.required)() : function () {},
              name: "options[".concat(index, "].choice"),
              inputProps: {
                'aria-label': 'secondary checkbox'
              },
              onChange: function onChange(event) {
                _this2.props.setFieldValue("options.".concat(index, ".choice"), event.target.value);
              }
            }) : null), !element.required && /*#__PURE__*/_react.default.createElement(_core.Grid, {
              item: true,
              container: true,
              xs: 1,
              justify: "flex-end",
              alignItems: "center"
            }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
              onClick: function onClick() {
                arrayHelpers.remove(index);

                _this2.handleRemoveOptionalOption(element);
              }
            }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "delete")))));
          }));
        }
      }));
    }
  }]);

  return OptionOfProductField;
}(_react.default.Component);

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    categories: state.categoryOfProductReducer ? state.categoryOfProductReducer.categories : null,
    options: state.optionOfProductReducer.options
  };
})(OptionOfProductField);

exports.default = _default;